import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateArrayDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";
import type { ICountryObject } from "app/services/CountryService";

export default class FindTopCountryFilter extends FilterPanelBaseFilter<readonly number[], readonly ICountryObject[]> {
    readonly permittedCountriesCount: number;
    constructor(deps: IFilterPanelBaseFilterDeps<readonly number[], readonly ICountryObject[]>) {
        super(deps);
        this.permittedCountriesCount = deps.options.filter((c) => c.permitted).length;
    }

    calculateValueDelta = (
        previousValue?: readonly number[],
        newValue?: readonly number[],
    ): FilterValueDelta<number> => {
        return calculateArrayDelta(previousValue, newValue);
    };
}
